<div>
  <ng-content select="[toc-header-left]"></ng-content>
  <div class="[ stack stack-space-3xs ] [ flex-1 ] [ text-center ]">
    <ng-content select="campus-toc-header-overline"></ng-content>
    <ng-content select="campus-toc-header-headline"></ng-content>
    <ng-content select="campus-toc-header-subhead"></ng-content>
    <ng-content select="campus-toc-header-select"></ng-content>
  </div>

  <ng-content select="campus-toc-header-image"></ng-content>
  <ng-content select="[toc-header-right]"></ng-content>
</div>
